module.exports = __webpack_public_path__ + "img/18.e170ee3f.svg";